import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { useQuery } from '@tanstack/react-query';
import { contentService, type AppLanguage } from '@/services/contentService';
import { currentLangAtom } from '@/store/langAtom';

export function useLanguages(): { languages: AppLanguage[]; isLoading: boolean } {
  const currentLang = useAtomValue(currentLangAtom);

  const { data: allLanguages = [], isLoading } = useQuery({
    queryKey: ['app-languages'],
    queryFn: contentService.getLanguages,
    staleTime: 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  });

  const languages = useMemo(() =>
    allLanguages.filter(l =>
      (l.activeFlag === 'Y' && l.ppVisibleFlag === 'Y') ||
      l.appLanguageCode === currentLang,
    ),
    [allLanguages, currentLang],
  );

  return { languages, isLoading };
}
